// components/AcessosRapidos.jsx
import React from 'react';

export default function AcessosRapidos() {
  const links = [
    'Cartão SUS', 'Vacinação', 'Unidades de Saúde', 'Agendamento Médico',
    'Exames', 'Transporte Paciente', 'Farmácia Municipal', 'Ouvidoria SUS'
  ];

  return (
    <section className="bg-white py-10 px-6">
      <h2 className="text-green-700 font-bold text-xl mb-4">ACESSO RÁPIDO</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {links.map((item, idx) => (
          <div
            key={idx}
            className="bg-green-700 text-white p-4 rounded text-center text-sm font-semibold hover:bg-green-600 cursor-pointer transition"
          >
            {item}
          </div>
        ))}
      </div>
    </section>
  );
}